import axios from "axios";
import { Modal } from "../../../BP2Components";
import FormComplete from "../../FormComplete";

export const handleChildPotentialEmotion = (form) => {
   if (form.getFieldsValue()?.hasOwnProperty("emotion_code")) {
      const Body = {
         text:
            form.getFieldsValue().emotion_code === ""
               ? form.setFieldsValue({
                    ml_finded_text: ""
                 })
               : form.getFieldsValue().emotion_code,
         model_name: "emo_model"
      };

      const headers = {
         "Content-Type": "application/json"
      };
      try {
         axios.post("https://vmt.com.pl/api/classifier", Body, { headers }).then((res) =>
            form.setFieldsValue({
               ml_finded_text: res?.data?.result?.description
            })
         );
      } catch (err) {
         console.log(err);
      }
   }
};

export const showFormInModal = (modalData, setModalData) => {
   if (modalData.openModal) {
      return (
         <Modal
            width={1000}
            onCancel={() => setModalData({ openModal: false })}
            isOpen={modalData.openModal}
         >
            <FormComplete
               //@ts-ignore
               formId={modalData?.dataForModal.formId}
               dataId={modalData?.dataForModal.recordId}
            />
         </Modal>
      );
   }
};
